/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharp_Pearl_Ant_WakeInputs */

const en_sharp_pearl_ant_wake = /** @type {(inputs: Sharp_Pearl_Ant_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User import`)
};

const de_sharp_pearl_ant_wake = /** @type {(inputs: Sharp_Pearl_Ant_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer-Import`)
};

/**
* | output |
* | --- |
* | "User import" |
*
* @param {Sharp_Pearl_Ant_WakeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sharp_pearl_ant_wake = /** @type {((inputs?: Sharp_Pearl_Ant_WakeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharp_Pearl_Ant_WakeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharp_pearl_ant_wake(inputs)
	return de_sharp_pearl_ant_wake(inputs)
});